module.exports = __webpack_public_path__ + "ColetteMillsAfter.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ColetteMillsAfter.jpg
// module id = 843
// module chunks = 0